export default __webpack_public_path__ + "static/cardImg1-a57bbd011bed1ecb5c7952b8f7a13914.webp";